import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, styled } from '@mui/material/styles';
import LoadingButton from '@mui/lab/LoadingButton';
import { Grid, Stack, Typography, Link, useMediaQuery, Box, FormHelperText, TextField } from '@mui/material';

// project imports
import AuthCardWrapper from 'components/Cards/AuthCardWrapper';
import logoImg from 'assets/images/raptor_tech_logo.png';
import { authLogin } from 'redux/slices/auth/authActions';
// import AuthLogin from '../auth-forms/AuthLogin';
// import Logo from 'ui-component/Logo';
// import AuthFooter from 'ui-component/cards/AuthFooter';

const AuthWrapper = styled('div')(({ theme }) => ({
    background: `linear-gradient(white, ${theme.palette.primary.main})`
    // minHeight: '100vh'
}));

const Login = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userInfo) {
            if (userInfo.admin_permissions.root_admin) {
                navigate('/management/organizations');
            } else {
                navigate('/home');
            }
        }
    }, [navigate, userInfo]);

    const formik = useFormik({
        initialValues: {
            username: '',
            password: '',
            submit: null
        },
        validationSchema: Yup.object({
            username: Yup.string().max(255).required('Username is required'),
            password: Yup.string().max(255).required('Password is required')
        }),
        onSubmit: (values, helpers) => {
            setLoading(true);
            dispatch(authLogin({ username: values.username, password: values.password }))
                .then(() => setLoading(false))
                .catch(() => setLoading(false));
        }
    });

    return (
        <AuthWrapper>
            <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }}>
                <Grid item xs={12}>
                    <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                        <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                            <AuthCardWrapper>
                                <Grid container spacing={2} alignItems="center" justifyContent="center">
                                    <Grid item sx={{ mb: 3 }}>
                                        <Link href="/">
                                            <img src={logoImg} width="150" alt="" />
                                        </Link>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid
                                            container
                                            direction={matchDownSM ? 'column-reverse' : 'row'}
                                            alignItems="center"
                                            justifyContent="center"
                                        >
                                            <Grid item>
                                                <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                    <Typography
                                                        color={theme.palette.primary.main}
                                                        gutterBottom
                                                        variant={matchDownSM ? 'h3' : 'h2'}
                                                    >
                                                        WakeSMART Administration Login
                                                    </Typography>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <form noValidate onSubmit={formik.handleSubmit}>
                                            <TextField
                                                error={Boolean(formik.touched.username && formik.errors.username)}
                                                fullWidth
                                                helperText={formik.touched.username && formik.errors.username}
                                                label="Username"
                                                margin="normal"
                                                name="username"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="username"
                                                value={formik.values.username}
                                            />
                                            <TextField
                                                error={Boolean(formik.touched.password && formik.errors.password)}
                                                fullWidth
                                                helperText={formik.touched.password && formik.errors.password}
                                                label="Password"
                                                margin="normal"
                                                name="password"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="password"
                                                value={formik.values.password}
                                            />
                                            {formik.errors.submit && (
                                                <Box sx={{ mt: 3 }}>
                                                    <FormHelperText error>{formik.errors.submit}</FormHelperText>
                                                </Box>
                                            )}
                                            <Box sx={{ mt: 2, fontFamily: 'sans-serif', fontSize: 8 }}>
                                                <Link href="/login/forgot_password" sx={{ float: 'right', textDecoration: 'none', mb: 1 }}>
                                                    Forgot Password?
                                                </Link>
                                                <LoadingButton
                                                    // disabled={formik.isSubmitting}
                                                    fullWidth
                                                    size="large"
                                                    type="submit"
                                                    variant="contained"
                                                    loading={loading}
                                                >
                                                    Log In
                                                </LoadingButton>
                                            </Box>
                                            <Box sx={{ mt: 2, textAlign: 'center', fontFamily: 'sans-serif', fontSize: 12 }}>
                                                <Link href="/register" sx={{ textDecoration: 'none' }}>
                                                    Don't have an account? Create a new one
                                                </Link>
                                            </Box>
                                        </form>
                                    </Grid>
                                </Grid>
                            </AuthCardWrapper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </AuthWrapper>
    );
};

export default Login;
